import { render, staticRenderFns } from "./searchInputComplex.vue?vue&type=template&id=528ed344&scoped=true&"
import script from "./searchInputComplex.vue?vue&type=script&lang=js&"
export * from "./searchInputComplex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ed344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528ed344')) {
      api.createRecord('528ed344', component.options)
    } else {
      api.reload('528ed344', component.options)
    }
    module.hot.accept("./searchInputComplex.vue?vue&type=template&id=528ed344&scoped=true&", function () {
      api.rerender('528ed344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempSearch/components/searchInputComplex.vue"
export default component.exports